import {
  CHANGE_LOCAL_DATA
} from '../actions/localDataActions';

const initialState = {};

export default function localData(state = initialState, action) {
  switch (action.type) {
    case CHANGE_LOCAL_DATA:
      return {
        ...state,
        ...(action.payload)
      };
    default:
      return state;
  }
}
